<template>
    <modal-template
        v-if="popUp"
        @on-close="closePopUp"
    >
        <div class="flex flex-col gap-4 max-w-[365px]">
            <p>Эта функция доступна только по подписке.</p>
            <p>Полный список преимуществ подписки можно найти на <a href="/account/subscribe/">странице с подробной информацией</a>. Вы также можете оформить подписку прямо сейчас, отправив заявку.</p>
            <enter-button @click="openSubscribeModal">
                Оформить подписку
            </enter-button>
        </div>
    </modal-template>
</template>

<script>
import ModalTemplate from "@/components/Modal/ModalTemplate";
import EnterButton from "@/components/Enter/Button";
import { subscribeModalActions, subscribeProviderKey } from "@/constants";
import { inject } from "vue";

export default {
    name: "SubscribeIsNeededModal",
    components: { ModalTemplate, EnterButton },
    props: {
        popUp: {
            type: Boolean,
            default: false,
        },
        closePopUp: {
            type: Function,
            required: true
        },
    },
    setup (props) {
        const subscribePopUpActions = inject(subscribeProviderKey);

        const openSubscribeModal = () => {
            if (!subscribePopUpActions) {
                return;
            }
            subscribePopUpActions[subscribeModalActions.OPEN_SUBSCRIBE_MODAL]();
            props.closePopUp();
        }

        return {
            openSubscribeModal,
        };
    },
}
</script>
<style scoped>
 a {
    background-color: #F6E5CC;
 }
</style>
